export default "__VITE_ASSET__B0C51ZPP__"